import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../common/Modal';
import { Select } from '../../common/Forms/Select';
import Form from '../../common/Forms/Form'
import CheckboxInput from '../../common/Forms/CheckboxInput'
import styles from './Form.module.sass'
import {
  Button,
  Grid,
} from '@material-ui/core'
import axios from 'axios';

const SchoolTransfer = ({ options, packageId }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setIsOpen(true);
  };
  const closeModal = () => setIsOpen(false);

  const handleSubmit = (options) => {
    if (!options.package_id) return;

    axios.post(`/admin/packages/${packageId}/transfer_schools?new_package=${options.package_id}&remove_schools=${options.remove_schools}`)
      .then(() => {
        window.location = `/admin/packages/${options.package_id}/edit`
      })
  };

  return (
    <Fragment>
      <button onClick={openModal} className="btn btn-primary">
        Transfer schools to a new pricelist
      </button>

      <Modal
        modalIsOpen={isOpen}
        closeModal={closeModal}
        contentLabel="Transfer Schools"
        headerText="Transfer Schools"
        modalBodyProps={{ className: styles.modalBody }}
      >
        <Form onSubmit={handleSubmit} styles={{ height: '500px' }}>
          <Select
            label="Pricelist to transfer schools to"
            name="package_id"
            isSearchable={true}
            options={options}
          />

          <CheckboxInput
            name='remove_schools'
            label="Remove schools from current pricelist after transfer?"
          />

          <Grid container justifyContent="flex-end">
            <Grid item>
              <Button
                fullWidth
                type="submit"
                variant="contained"
                color="primary"
              >
                Transfer Schools
              </Button>
            </Grid>
          </Grid>
        </Form>
      </Modal>
    </Fragment>
  );
};

SchoolTransfer.propTypes = {
  options: PropTypes.array,
  selectedValues: PropTypes.array
};

SchoolTransfer.defaultProps = {
  options: [{}],
  selectedValues: [{}]
};

export default SchoolTransfer;
